import * as actionTypes from  "../actions/CommiteeActions"

const initialState = {
  Loading: false,

  commiteeList: [],

  getUser :[],
  commiteeRecord: [],
  commiteeDropdownList: [],
  workspaceAttachmentList: [],
  validation_error: "",
  attachment_validation_error: "",
  redirect_to_list: false,
  showDeleteModel: false,
  showUpdateForm: false,
  showViewPage: false,
  closeModal:false,
  session: null, // Add session state
};
const CommiteeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.COMMITEE_REQUEST:
      return {
        ...state,
        Loading: true,
        validation_error: "",
        redirect_to_list: false,
      };
  
    case actionTypes.USER_ACCESS:
      return {
        getUser:action.getUser,
      }  

      case actionTypes.COMMITEE_USERS_ACCESS:
        return {
          getCommiteeUsers:action.getCommiteeUsers
        }
    case actionTypes.COMMITEE_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        commiteeList: action.commiteeList,
        showUpdateForm: false,
        showViewPage: false,
        commiteeRecord: [],
      };
 
    case actionTypes.COMMITEE_SERVER_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        showUpdateForm: false,
        showViewPage: false,
        commiteeRecord: [],
      };
    case actionTypes.COMMITEE_GET_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        commiteeRecord: action.record,
        showUpdateForm: action.actionType === "update" ? true : false,
        showViewPage: action.actionType === "view" ? true : false,
      };
    case actionTypes.COMMITEE_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        Loading: false,
        commiteeDropdownList: action.commiteeDropdownList,
      };
    case actionTypes.COMMITEE_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.HIDE_COMMITEE_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key])
        delete state.validation_error[action.feild_key];
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.REDIRECT_TO_COMMITTE_LIST:
      return {
        ...state,
        redirect_to_list: true,
        showUpdateForm: false,
        showViewPage: false,
        validation_error: "",
        commiteeRecord: [],
      };

  

    default:
      return state;

   
  }
};

export default CommiteeReducer;
